import { render, staticRenderFns } from "./DiscriptionCard.vue?vue&type=template&id=67c3ff0b&scoped=true"
import script from "./DiscriptionCard.vue?vue&type=script&lang=js"
export * from "./DiscriptionCard.vue?vue&type=script&lang=js"
import style0 from "./DiscriptionCard.vue?vue&type=style&index=0&id=67c3ff0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3ff0b",
  null
  
)

export default component.exports